// extracted by mini-css-extract-plugin
export var createdDate = "_lx-1";
export var divider = "_lx-2";
export var headerDivider = "_lx-3";
export var messagesCard = "_lx-0";
export var messagesContainer = "_lx-7";
export var messagesContainerWrapper = "_lx-4";
export var pointerCapturingButtonBoxes = "_lx-a";
export var showLeftPanelButton = "_lx-9";
export var showMoreButton = "_lx-c";
export var showMoreButtonContainer = "_lx-b";
export var summaryTitle = "_lx-6";
export var systemMessageCardWrapper = "_lx-d";
export var topButtons = "_lx-8";
export var withPadding = "_lx-5";